"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var LinearProgress = (0, styles_1.styled)(material_1.LinearProgress)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: theme.spacing(1),
            borderRadius: theme.spacing(1)
        },
        _b["&.".concat(material_1.linearProgressClasses.colorPrimary)] = {
            backgroundColor: theme.palette.grey.A100,
        },
        _b["& .".concat(material_1.linearProgressClasses.bar)] = {
            borderRadius: theme.spacing(1),
            background: theme.palette.primary.main,
        },
        _b);
});
exports.default = (0, DefaultPropsHoC_1.default)(LinearProgress, {
    variant: 'determinate',
});
